/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KycLink
 */
export interface KycLink {
    /**
     * 
     * @type {string}
     * @memberof KycLink
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof KycLink
     */
    link?: string;
}

/**
 * Check if a given object implements the KycLink interface.
 */
export function instanceOfKycLink(value: object): boolean {
    return true;
}

export function KycLinkFromJSON(json: any): KycLink {
    return KycLinkFromJSONTyped(json, false);
}

export function KycLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): KycLink {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'link': json['link'] == null ? undefined : json['link'],
    };
}

export function KycLinkToJSON(value?: KycLink | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'link': value['link'],
    };
}

